import React, { useMemo } from 'react';
import RFQProductTemplatesTable from 'components/rfq/product-template/rfq-product-templates/RFQProductTemplatesTable';
import RFQProductTemplatesStore, {
  PageStoreContext,
} from 'store/pages/rfq/rfq-template/rfq-product-templates/pageStore';
import { NavSection } from 'components/rfq/product-template/rfq-product-templates/NavSection';
import { ProductTemplatesActions } from 'components/rfq/product-template/rfq-product-templates/ProductTemplatesActions';
import { FiltersActionBar } from 'components/rfq/product-template/rfq-product-templates/FiltersActionBar';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import { PageHeaderStyled } from './styles';

const RFQProductTemplatesPage: React.FC = () => {
  const pageStore = useMemo(() => new RFQProductTemplatesStore(), []);

  return (
    <NoSidebarPageLayout contentWidth="wide" pageHeader={<PageHeaderStyled title="UW Product Templates" />}>
      <PageStoreContext.Provider value={pageStore}>
        <NavSection />
        <ProductTemplatesActions />
        <FiltersActionBar />
        <RFQProductTemplatesTable />
      </PageStoreContext.Provider>
    </NoSidebarPageLayout>
  );
};

export default RFQProductTemplatesPage;
